/* Get Browser */
document.addEventListener("DOMContentLoaded", function () {
  let browser = "unknown";

  if (
    navigator.userAgent.indexOf("Chrome") !== -1 &&
    navigator.userAgent.indexOf("Edg") === -1
  ) {
    browser = "browser--chrome";
  } else if (navigator.userAgent.indexOf("Firefox") !== -1) {
    browser = "browser--firefox";
  } else if (
    navigator.userAgent.indexOf("Safari") !== -1 &&
    navigator.userAgent.indexOf("Chrome") === -1
  ) {
    browser = "browser--safari";
  } else if (navigator.userAgent.indexOf("Edg") !== -1) {
    browser = "browser--edge";
  } else if (
    navigator.userAgent.indexOf("Opera") !== -1 ||
    navigator.userAgent.indexOf("OPR") !== -1
  ) {
    browser = "browser--opera";
  } else if (
    navigator.userAgent.indexOf("MSIE") !== -1 ||
    navigator.userAgent.indexOf("Trident") !== -1
  ) {
    browser = "browser--ie";
  }

  document.body.classList.add(browser);
});

/* Hide empty blocks */
document.addEventListener("DOMContentLoaded", function () {
  const selectors = [".shopify-block", ".social-icons__wrapper"];

  selectors.forEach((selector) => {
    const elements = document.querySelectorAll(selector);

    elements.forEach((el) => {
      if (!el.innerHTML.trim()) {
        el.style.display = "none";
      }
    });
  });
});

/* Get footer height */
/* Get header and footer heights */
document.addEventListener("DOMContentLoaded", function () {
  var footer = document.querySelector("footer");

  var footerHeight = footer.offsetHeight;

  document.documentElement.style.setProperty(
    "--footer-height",
    footerHeight + "px"
  );
});

const header = document.querySelector('header-component');

if (header) {
  const setHeaderHeight = () => {
    document.documentElement.style.setProperty(
      '--header-height',
      `${header.offsetHeight}px`
    );
  };

  new ResizeObserver(setHeaderHeight).observe(header);
}


/* DIALOG */
function initDialog(triggerId, dialogId, closeSelector) {
  const trigger = document.getElementById(triggerId);
  const dialog = document.getElementById(dialogId);
  if (!trigger || !dialog) return;

  trigger.addEventListener("click", (e) => {
    e.preventDefault();
    dialog.showModal();
  });

  dialog
    .querySelector(closeSelector)
    ?.addEventListener("click", () => dialog.close());

  // Close when clicking the backdrop
  dialog.addEventListener("click", (e) => {
    if (e.target === dialog) dialog.close();
  });
}

initDialog("conditions", "conditions-dialog", ".dialog-close");
initDialog("size-guide--button", "size-guide", ".lightbox__close");



// FEATURED COLLECTIONS

// (() => {
//   const SELECTOR = ".featured-collection";
//   const ACTIVE_CLASS = "is-active";
//   const INACTIVE_CLASS = "is-inactive";

//   const sections = Array.from(document.querySelectorAll(SELECTOR));
//   if (!sections.length) return;

//   // Build id -> element map for quick lookup
//   const byId = new Map(sections.filter((el) => el.id).map((el) => [el.id, el]));

//   function setActive(target) {
//     if (!target) return;

//     sections.forEach((el) => {
//       const isActive = el === target;
//       el.classList.toggle(ACTIVE_CLASS, isActive);
//       el.classList.toggle(INACTIVE_CLASS, !isActive);
//       el.setAttribute("aria-current", isActive ? "true" : "false");
//     });
//   }

//   // 1) Page load: first active by default
//   // If URL already has a hash for a valid section, prefer that
//   const initialHash = decodeURIComponent(window.location.hash || "").replace(
//     "#",
//     "",
//   );
//   setActive(byId.get(initialHash) || sections[0]);

//   // 2) Click handler for links that target these sections
//   document.addEventListener("click", (e) => {
//     const a = e.target.closest('a[href^="#"]');
//     if (!a) return;

//     const hash = decodeURIComponent(a.getAttribute("href"));
//     const id = hash.slice(1);
//     const target = byId.get(id);
//     if (!target) return;

//     // Optional: prevent default and smooth scroll ourselves
//     // If you prefer native jump/scroll, remove preventDefault + scrollIntoView
//     e.preventDefault();
//     target.scrollIntoView({ behavior: "smooth", block: "start" });

//     // Update URL hash without forcing jump
//     history.pushState(null, "", `#${encodeURIComponent(id)}`);

//     // Immediately set active so blur updates as it scrolls
//     setActive(target);
//   });

//   // 3) Keep active section in sync on scroll (IntersectionObserver)
//   // We'll pick the section most "central" in view.
//   let activeEl =
//     document.querySelector(`${SELECTOR}.${ACTIVE_CLASS}`) || sections[0];

//   const observer = new IntersectionObserver(
//     (entries) => {
//       // Consider only intersecting entries
//       const visible = entries.filter((en) => en.isIntersecting);
//       if (!visible.length) return;

//       // Pick the one with highest intersection ratio
//       visible.sort((a, b) => b.intersectionRatio - a.intersectionRatio);
//       const top = visible[0].target;

//       if (top && top !== activeEl) {
//         activeEl = top;
//         setActive(activeEl);

//         // Optional: keep URL hash updated while scrolling (comment out if you don't want this)
//         if (activeEl.id) {
//           history.replaceState(null, "", `#${encodeURIComponent(activeEl.id)}`);
//         }
//       }
//     },
//     {
//       // Tune these to match the "active zone" you want
//       // This makes "active" switch when the section is near mid viewport.
//       root: null,
//       threshold: [0.15, 0.5, 0.75],
//       rootMargin: "-40% 0px -40% 0px",
//     },
//   );

//   sections.forEach((el) => observer.observe(el));

//   // 4) If user navigates with back/forward and hash changes, sync active
//   window.addEventListener("hashchange", () => {
//     const id = decodeURIComponent(window.location.hash || "").slice(1);
//     const target = byId.get(id);
//     if (target) setActive(target);
//   });
// })();